import { actionTypes } from "./actions";

const initialState = {
  data: {},
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_MENUS:
      return {
        ...state,
        data: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
